// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookHandLuggageModalLayout-desktop__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/BookHandLuggageModalLayout/BookHandLuggageModalLayout.desktop.scss
 ** module id = 948
 ** module chunks = 1
 **/